(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_banner_section"] && !Shopify.designMode) return;
  try {
    

$('.main-carousel').flickity({ autoPlay: 12000});

  } catch(e) { console.error(e); }
})();
})();
